import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getAllManufacturedItems({ commit }, params = {} ) {
    return axios.get(`/manufactured_items`, { params })
  },
  searchAllManufacturedItems({ commit }, params = {} ) {
    return axios.get(`/manufactured_items/search`, { params })
  },
  getManufacturedItems({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/manufactured_items`, { params })
  },
  searchManufacturedItems({ commit }, { supplierId, params = {} } ) {
    return axios.get(`/suppliers/${supplierId}/manufactured_items/search`, { params })
  },
  getManufacturedItem({ commit }, id) {
    return axios.get(`/manufactured_items/${id}`)
  },
  createManufacturedItem({ commit }, data) {
    return axios.post('/manufactured_items', data)
  },
  updateManufacturedItem({ commit }, data) {
    return axios.put(`/manufactured_items/${data.id}`, data)
  },
  importManufacturedItems({commit}, params = {}) {
    const formData = new FormData()
    formData.append('file', params.file, params.file.name)
    formData.append('type', params.type)
    formData.append('force_save', params.force_save)
    formData.append('download_error', params.download_error)
    formData.append('supplier_id', params.supplierId)
    return axios.post('/manufactured_items/import', formData)
  },
}
